module.exports = __webpack_public_path__ + "img/LauterAlsDasWasser.5833062e.jpg";